import { ChangeDetectionStrategy, Component, Input, OnChanges, OnInit } from '@angular/core';
import { UserModel } from '@common/models/User.model';
import { currentUserSubject } from '@common/services/user.service';

@Component({
    selector: 'app-mrn-number',
    template: `
        @if (displayMrnLink !== '') {
            <a class="row-link" [routerLink]="['/customs/declaration-view', mrnId]">
                {{ displayMrnLink }}
            </a>
        }
        @if (displayMrnLink === '') {
            {{ displayMrnString }}
        }
    `,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class MrnNumberComponent implements OnInit, OnChanges {
    @Input() mrnId?: string;
    @Input() mrnCode?: string;
    @Input() mrnType?: string;
    @Input() declarationType?: string;
    @Input() mrnString?: string;
    @Input() lrn?: string;

    displayMrnString: string = '';
    displayMrnLink: string = '';
    user: UserModel;

    constructor() {
        currentUserSubject.subscribe((user) => {
            this.user = user;
        });
    }

    ngOnInit(): void {
        this.updateDisplay();
    }

    ngOnChanges(): void {
        this.updateDisplay();
    }

    private updateDisplay(): void {
        this.displayMrnLink = '';
        this.displayMrnString = '';

        if (this.mrnCode) {
            this.displayMrnString = this.mrnCode;
            if (this.mrnId && this.userHasPermission()) {
                this.displayMrnLink = [this.mrnType, this.mrnCode].filter((val) => val).join(' - ');
            }
        } else if (this.declarationType || this.mrnString) {
            this.displayMrnString = [this.declarationType, this.mrnString].filter((val) => val).join(' - ');
        } else {
            this.displayMrnString = this.lrn || '';
        }
    }

    userHasPermission(): boolean {
        if (this.user.hasPermission('Customs.CustomsDeclarationsList.ViewAdmin')) return true;
        if (this.user.hasPermission('Customs.CustomsDeclarationsList.ViewCustoms')) {
            // TODO: Implement logic to allow only for terminals, assigned to user's customs office
            // userToCustomsOffices.Any(rel =>
            //    rel.CustomsOffice.Id == x.LodgingOffice.Id ||
            //    rel.CustomsOffice.Id == x.SupervisingOffice.Id ||
            //    rel.CustomsOffice.Id == x.Sender.Id ||
            //    rel.CustomsOffice.Id == x.PresentationOffice.Id
            return true;
        }
        if (this.user.hasPermission('Customs.CustomsDeclarationsList.ViewAgents')) {
            // TODO: Implement logic to allow only for declarations, submitted by user's organizaction
            // x.Declarant == currentUser.Organization.EORINumber
            return true;
        }
        if (this.user.hasPermission('Customs.CustomsDeclarationsList.ViewTerminal')) return false;

        return false;
    }
}
